import React from "react";
import FontLoader from "../components/FontLoader";

/**
 * This is a higher-order component that wraps any authentication component
 * and ensures fonts are properly loaded after authentication
 */
export const withFontLoading = <P extends object>(AuthComponent: React.ComponentType<P>) => {
  return function WithFontLoading(props: React.ComponentProps<typeof AuthComponent> & React.PropsWithChildren<object>) {
    return (
      <AuthComponent {...props}>
        <FontLoader>{props.children}</FontLoader>
      </AuthComponent>
    );
  };
};
